'use client';
import { useRef } from 'react';

/**
 * Используется для создания изменяемого ref, хранящего состояние.
 *
 * @template T Тип состояния, которое будет храниться в ref.
 * @param {T} initialValue Начальное значение для ref.
 *
 * @returns {[() => T, (value: T) => void]}
 * Кортеж, содержащий функцию для получения текущего значения
 * и функцию для установки нового значения.
 *
 * Пример использования:
 *
 * const [getValue, setValue] = useStateRef(0);
 * console.log(getValue()); // 0
 * setValue(10);
 * console.log(getValue()); // 10
 */ const useStateRef = (initialValue)=>{
    const ref = useRef(initialValue);
    const setRef = (value)=>ref.current = value;
    return [
        ()=>ref.current,
        setRef
    ];
};

export { useStateRef };
//# sourceMappingURL=useStateRef.js.map
